import { inject, Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { environment } from '../../../environments/environment';
import { StorageManager } from 'src/app/common/storage-manager.class';

@Injectable({
    providedIn: 'root'
})
export class ShowMapasGuardService {

    public nombre = StorageManager.getUser().nombre;
    public apellidos = StorageManager.getUser().apellidos ? StorageManager.getUser().apellidos : '';
    public appName = environment.appName;

    private readonly router = inject(Router);

    canActivate(): boolean | UrlTree {
        if ((this.appName !== 'manezylozano'
            && this.nombre.toLowerCase() !== 'quique'
            && this.apellidos.toLowerCase() !== 'lozano')
            && !environment.features.showMapas) {
            return this.router.parseUrl('/login');
        }

        return true;
    }
}
